document.addEventListener("DOMContentLoaded", () => {

  // card-product, 产品颜色切换
  function debounce(func, delay) {
    let timeout;
    return function(...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  }
  
  // 事件处理函数
  const handleMouseEnterLeave = debounce(function (event) {
    var $this = $(this);
    var $wrapper = $this.parents(".product-card-wrapper");
    if (event.type === "mouseover" || event.type === "click") {
      // 鼠标移入或点击时
      $this.siblings(".color-btn").removeClass("active");
      $this.addClass("active");
  
      var url = $this.attr("data-img");
      $wrapper.find(".pro-featured-media").attr("srcset", url);
      $wrapper.addClass("card-wrapper-hover");
    } else if (event.type === "mouseout") {
      // 鼠标移出时
      $wrapper.removeClass("card-wrapper-hover");
    }
  }, 200); 
  
  // 绑定事件
  $(".pro-color-list .color-btn").on("mouseover mouseout click", handleMouseEnterLeave);

  // data-product-handle 可能是纯 handle，也可能是 "handle?variant=变体id"。
  // /products/handle.js 返回整个产品，不会按 ?variant= 过滤，所以要自己在 variants 里取图。
  const imageSrcFromPayload = function (image) {
    if (!image) return "";
    if (typeof image === "string") return image;
    return image.src || "";
  };

  const handleMouseEnterLeaveFakeColor = debounce(function (event) {
    const $this = $(this);
    const $wrapper = $this.parents(".product-card-wrapper");
    const eImage = $wrapper.find(".pro-featured-media");
  
    if (event.type === "mouseover" || event.type === "click") {
      // 鼠标移入或点击时
      $this.siblings(".color-btn").removeClass("active");
      $this.addClass("active");

      const rawHandle = ($this.attr("data-product-handle") || "").trim();
      const handleParts = rawHandle.split("?");
      const handle = handleParts[0].replace(/\.js$/, "");
      const variantId = new URLSearchParams(handleParts[1] || "").get("variant");
      if (!handle) return;

      const url = window.Shopify.routes.root + "products/" + handle + ".js";
      // 快速划过多个色块时，只采用最后一次请求的结果
      const requestId = ($wrapper.data("fakeColorRequest") || 0) + 1;
      $wrapper.data("fakeColorRequest", requestId);

      $.getJSON(url, function (product) {
        if ($wrapper.data("fakeColorRequest") !== requestId) return;

        let src = imageSrcFromPayload(product.featured_image);
        if (variantId && Array.isArray(product.variants)) {
          const variant = product.variants.find(function (item) {
            return String(item.id) === String(variantId);
          });
          const variantSrc = imageSrcFromPayload(variant && variant.featured_image);
          if (variantSrc) src = variantSrc;
        }
        if (src) eImage.attr("srcset", src);
      });
  
      $wrapper.addClass("card-wrapper-hover");
    } else if (event.type === "mouseout") {
      // 鼠标移出时
      $wrapper.removeClass("card-wrapper-hover");
    }
  }, 200);
  
  // 绑定事件
  $(".product-card-wrapper .fake-color-list [data-fake-color-swatch-item]").on("mouseover mouseout click", handleMouseEnterLeaveFakeColor);


  // 检测筛选，给产品颜色重新添加事件
  function ExamineGrid () {
    const ExamineElement = document.querySelector(".product-grid-container");
    if (ExamineElement) {
      const GridObserver = new MutationObserver(function (mutationsList) {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList" || mutation.type === "attributes") {
          $(".pro-color-list .color-btn").on("mouseover mouseout click", handleMouseEnterLeave);
          $(".product-card-wrapper .fake-color-list [data-fake-color-swatch-item]").on("mouseover mouseout click", handleMouseEnterLeaveFakeColor);
        }
      }
    });
  
    const config = {
      attributes: true, 
      childList: true, 
      subtree: true, 
    };
    
    GridObserver.observe(ExamineElement, config);
  }
}

 ExamineGrid()

  

  // 监测侧边购物车类名变化
  var element = document.querySelector("cart-drawer");
  var observer = new MutationObserver(function (mutationsList, observer) {
    for (var mutation of mutationsList) {
      if ( mutation.type === "attributes" && mutation.attributeName === "class") {
        // 检查是否有 .active 类
        // if (element.classList.contains("active")) {
        //     // $('body').addClass('overflow-hidden')
        //     // $('body').css('overflow', 'hidden')
        // } else {
        //   // $('body').removeClass('overflow-hidden')
        //   $('body').css('overflow', 'visible')
        // }

        closeCart()
      }
    }
  });
  observer.observe(element, { attributes: true });

  function closeCart () {
    $('.cart-drawer__overlay').click(function(){
      if ($('cart-drawer').hasClass("active")) {
        $('cart-drawer').removeClass('active')
       $('body').css('overflow', 'visible')
     }
   })
  }

  closeCart()
  



  // smile 插件
  var lastScrollTop = 0;
  
  window.addEventListener('scroll', function () {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop) {
      $('.smile-launcher-frame-container').css('display', 'none');
    } else {
      $('.smile-launcher-frame-container').css('display', 'block');
    }

    lastScrollTop = scrollTop;
  });


});
